import React from 'react';
import ItemSelected from './ItemSelected.jsx';
import ShowIf from './ShowIf.jsx';

class DataSelected extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: this.props.dataSelected,
      value: this.props.value,
      only: this.props.only,
      dataOptions: this.props.dataOptions,
      thanhTraCQQL: this.props.thanhTraCQQL,
      keyName: this.props.keyName
    }
  }

  removeSelected(index) {
    let dataPush = {
      value: this.state.data[index].value,
      label: this.state.data[index].label
    }
    this.props.removeSelected(dataPush);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.dataSelected,
      dataOptions: nextProps.dataOptions,
      thanhTraCQQL: this.props.thanhTraCQQL,
      only: nextProps.only,
      value: nextProps.value,
      keyName: nextProps.keyName
    })
  }

  toggleOption(e) {
    this.props.toggleOption();
  }

  render() {
    let dataSelected = this.state.data.map((state, index) => {
      let getQuanHuyen = '';
      let check = this.props.dataOptions.findIndex(item => item.coQuanQuanLyCha && item.coQuanQuanLyCha.capCoQuanQuanLyId === parseInt(this.props.thanhTraCQQL) && item.coQuanQuanLyId === state.value);
      if (check !== -1) {
        getQuanHuyen = ' - ' + this.props.dataOptions[check].coQuanQuanLyCha.ten;
      }
      return (
        <ItemSelected key={index} only={this.state.only} capQuanHuyen={getQuanHuyen} thanhTraCQQL={this.props.thanhTraCQQL} label={state.label} value={state.value} index={index} removeSelected={this.removeSelected.bind(this, index)}/>
      )
    })
    let dataOptions = [...this.state.dataOptions]
    let value = dataOptions.filter(state => {
      return state[this.state.keyName] == this.state.value
    })
    return (
      <section className='rs-wrap-selected'>
        <div className="rs-data-selected">
          <span className='rs-data-selected-background' name={this.props.name} onClick={this.toggleOption.bind(this)}></span>
          <ShowIf condition={this.state.only}>
            <span className='rs-place-holder rs-value'>{value.length > 0 ? value[0].ten : ''}</span>
          </ShowIf>
          <ShowIf condition={!this.state.only}>
            {dataSelected}
          </ShowIf>
        </div>
      </section>
    );
  }
}

DataSelected.defaultProps = {
  dataSelected: [],
  dataOptions: [],
  value: '',
  only: false,
  keyName: '',
  name: ''
}

export default DataSelected;



// WEBPACK FOOTER //
// ./src/components/tt-forms/react-tree-select/DataSelected.jsx